'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isError(value) {
    return value instanceof Error;
}

exports.isError = isError;
